import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  FormControl,
  FormGroup,
  Grid,
  Icon,
  TextField,
} from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fab from "@material-ui/core/Fab";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Search from "@material-ui/icons/Search";
import { saveAs } from "file-saver";
import _ from "lodash";
import { debounce } from "lodash";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import SelectAutoComplete from "../../components/SelectAutoComplete";
import { mapActionsToProps } from "../../redux/cloudPBX/inboundCall";
import { exportInbound } from "../../redux/cloudPBX/inboundCall";
import { mapActionsToProps as phoneNumberAction } from "../../redux/cloudPBX/phoneNumber";
import { mapActionsToProps as provinceAction } from "../../redux/user";
import Dialog from "./../../components/Dialog";
import TableData from "./../../components/TableData";
import datetimeHelper from "./../../helper/datetime-helper";
import { globalHistory } from "./../../history";
import { mapActionsToProps as agent } from "./../../redux/agent";
import { mapActionsToProps as clickToCallAction } from "./../../redux/cloudPBX/clickToCall";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const styles = (theme) => ({
  model: {
    width: "100%",
  },
  card: {
    maxWidth: "100%",
    overflow: "unset",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  chip: {
    margin: "0 2px 0 2px !important",
    padding: "2px",
    height: "18px",
  },
  chips: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
  bulletOffline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "red",
  },
  bulletOnline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "chartreuse",
  },
  button: {
    width: "90px",
    height: "35px",
    float: "right",
    marginTop: "-55px",
    fontSize: "16px",
  },
});

function filterCustomers(array, search) {
  if (search) {
    return search
      ? array.filter(
          (item) =>
            (item &&
              item.user &&
              item.user.username &&
              item.user.username
                .toLowerCase()
                .includes(search.toLowerCase())) ||
            (item &&
              item.user &&
              item.user.fullname &&
              item.user.fullname.toLowerCase().includes(search.toLowerCase()))
        )
      : array;
  }
  return array;
}

const getRecordFileUrl = (item) => {
  if (
    item.recordFileS3 &&
    item.recordFileS3 !== "not-exists" &&
    !item.recordFileS3.includes("error")
  ) {
    return item.recordFileS3;
  } else if (item.recordFile) {
    return item.recordFile;
  }
  return "";
};

class PostmanCalls extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      note: "",
      length: 0,
      data: [],
      modalSend: false,
      filters: {
        order: "startedAt DESC",
        where: {
          gte: datetimeHelper.toFormat(new Date(), "YYYY-MM-DD startDayNoSec"),
          lte: datetimeHelper.toFormat(new Date(), "YYYY-MM-DD endDayNoSec"),
          toNumber: {
            inq: ["18002009", "02471060002"],
          },
          "variables.businessId": "goi-ra-buu-ta",
          ivrExtension: null,
          answeredDuration: null,
        },
        page: 0,
        pageSize: 20,
      },
      item: null,
      modalEdit: false,
      modalDelete: false,
      showPassword: false,
      modalAction: false,
      agentGroupId: null,
      loadingExcel: false,
      multipleSelectedValue: [],
      labelWidth: 0,
      listItem: [],
      listUser: [],
      selectedUser: "",
      listExtension: [],
      selectedProvince: "",
    };
  }
  componentDidMount() {
    this.itemInit();
    this.history = globalHistory();
    this.props.getListPhoneNumber();
    this.props.getListGroupAgent();
    // this.setState({
    //     labelWidth: ReactDOM.findDOMNode(this.InputLabelRef).offsetWidth,
    // });
  }

  static getDerivedStateFromProps(props, state) {
    const { listPhoneNumber } = props;
    const listPhoneNumberResult =
      typeof listPhoneNumber === "object"
        ? Object.keys(listPhoneNumber).map((key) => listPhoneNumber[key])
        : listPhoneNumber;
    const listItem = listPhoneNumberResult.map((item) => item.id);
    if (!state.listItem.length) {
      return {
        multipleSelectedValue: listItem.filter((item) => item === "1900545481")
          .length
          ? listItem.filter((item) => item === "1900545481")
          : [],
        listItem: listItem,
      };
    }
    if (
      JSON.parse(JSON.stringify(state.listUser)) !==
        JSON.parse(JSON.stringify(_.values(props.listUser))) &&
      !state.listUser
    ) {
      return {
        listUser: _.values(props.listUser),
      };
    }
    if (
      JSON.parse(JSON.stringify(state.listExtension)) !==
        JSON.parse(JSON.stringify(_.values(props.listExtension))) &&
      !state.listExtension.length
    ) {
      return {
        listExtension: _.values(props.listExtension),
      };
    }
    return null;
  }

  listColumns = [
    {
      id: "subOrgNamePostmanCalls",
      numeric: true,
      disablePadding: false,
      label: "Bưu cục",
    },
    {
      id: "fromNumber",
      numeric: true,
      disablePadding: false,
      label: "SĐT bưu tá",
    },
    {
      id: "toNumber",
      numeric: true,
      disablePadding: false,
      label: "SĐT đón",
    },
    {
      id: "referVia",
      numeric: true,
      disablePadding: false,
      label: "SĐT gọi",
    },
    {
      id: "referTo",
      numeric: true,
      disablePadding: false,
      label: "Số điện thoại KH",
    },
    {
      id: "startedAt",
      numeric: true,
      disablePadding: false,
      label: "Thời gian gọi",
    },
    { id: "status", numeric: true, disablePadding: false, label: "Trạng thái" },
    {
      id: "attributes",
      _attributes: "ladingCode",
      numeric: true,
      disablePadding: false,
      label: "Mã vận đơn",
    },
    {
      id: "recordFileS3",
      numeric: true,
      disablePadding: false,
      label: "Ghi âm",
    },
    { id: "view", numeric: true, disablePadding: false, label: "Hành động" },
  ];

  itemInit() {
    const where = {};
    const and = [];
    const { filters, agentGroupId } = this.state;
    filters.where = this.objectWithKeySorted(filters.where);
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "status":
              if (element.startsWith("missed")) {
                if (element === "missedNoExtension") {
                  where["extensionId"] = { eq: "" };
                } else if (element === "missed") {
                  where["extensionId"] = { neq: "" };
                }
                where[key] = "missed";
              } else {
                where[key] = element;
              }
              break;
            case "extensionId":
              if (
                JSON.stringify(where["extensionId"]) === '{"neq":""}' ||
                !where["extensionId"]
              ) {
                where[key] = element;
              } else {
                where[key] = { eq: "" };
              }
              break;
            case "answeredDuration":
              let _and = [];
              switch (element) {
                case "1":
                  _and = [
                    {
                      answeredDuration: {
                        gte: 0,
                      },
                    },
                    {
                      answeredDuration: {
                        lt: 60,
                      },
                    },
                  ];
                  break;
                case "2":
                  _and = [
                    {
                      answeredDuration: {
                        gte: 60,
                      },
                    },
                    {
                      answeredDuration: {
                        lt: 180,
                      },
                    },
                  ];
                  break;
                case "3":
                  _and = [
                    {
                      answeredDuration: {
                        gte: 180,
                      },
                    },
                    {
                      answeredDuration: {
                        lt: 300,
                      },
                    },
                  ];
                  break;
                case "4":
                  _and = [
                    {
                      answeredDuration: {
                        gte: 300,
                      },
                    },
                    {
                      answeredDuration: {
                        lt: 600,
                      },
                    },
                  ];
                  break;
                case "5":
                  _and = [
                    {
                      answeredDuration: {
                        gte: 600,
                      },
                    },
                  ];
                  break;
                default:
                  break;
              }
              where.and = and.concat(_and);
              break;
            case "fromNumber":
            case "toNumber":
            default: {
              if (key.startsWith("gte") || key.startsWith("lte")) {
                if (key == "gte") {
                  and.push({
                    startedAt: { gte: this.state.filters.where.gte },
                  });
                  where.and = and;
                } else {
                  and.push({
                    startedAt: { lte: this.state.filters.where.lte },
                  });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    // this.props.getSubOrg()
    if (agentGroupId === null) {
      this.props.getList(filters.order, filters.pageSize, filters.page, {
        where,
      });
    } else {
      this.props.getInboundCallAgent(
        agentGroupId,
        filters.order,
        filters.pageSize,
        filters.page,
        {
          where,
        }
      );
    }
    this.props.getListAgent(
      filters.order,
      filters.pageSize,
      filters.page,
      {
        where,
      },
      {
        include: [
          { relation: "group", scope: { fields: { id: true, name: true } } },
        ],
      },
      { query: "all" }
    );
    this.props.countInboundCall({ where });
  }

  objectWithKeySorted = (object) => {
    let result = {};
    _.forEach(Object.keys(object).sort().reverse(), function (key) {
      result[key] = object[key];
    });
    return result;
  };

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleChangeMultiSelect = (event) => {
    const value = event.target.value;
    const name = event.target.name;
    const { filters } = this.state;
    const { listPhoneNumber } = this.props;
    const listPhoneNumberResult =
      typeof listPhoneNumber === "object"
        ? Object.keys(listPhoneNumber).map((key) => listPhoneNumber[key])
        : listPhoneNumber;
    const isSelectedAll = event.target.value.filter(
      (item) => item === "all"
    ).length;
    if (event.target.value.length < this.state.multipleSelectedValue.length) {
      const length = listPhoneNumberResult.map((value) => {
        return value.id;
      }).length;
      const selectedItems =
        event.target.value.length === length
          ? isSelectedAll
            ? event.target.value.filter((item) => item !== "all")
            : []
          : event.target.value.filter((item) => item !== "all");
      filters.where[name] = {
        inq: selectedItems,
      };
      this.setState({ multipleSelectedValue: selectedItems, filters });
    } else {
      if (isSelectedAll) {
        const selectedItems = ["all"].concat(
          listPhoneNumberResult.map((value) => {
            return value.id;
          })
        );
        filters.where[name] = {
          inq: selectedItems,
        };
        this.setState({ multipleSelectedValue: selectedItems, filters });
      } else {
        const length = listPhoneNumberResult.map((value) => {
          return value.id;
        }).length;
        const selectedItems =
          this.state.multipleSelectedValue.length === length - 1
            ? ["all"].concat(event.target.value)
            : event.target.value;
        filters.where[name] = {
          inq: selectedItems,
        };
        this.setState({
          multipleSelectedValue:
            this.state.multipleSelectedValue.length === length - 1
              ? ["all"].concat(event.target.value)
              : event.target.value,
          filters,
        });
      }
    }
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };

  handleSearchGroup = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    this.setState({
      [name]: value,
    });
  };

  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    if (filters.where && filters.where.toNumber) {
      filters.where.toNumber.inq = filters.where.toNumber.inq.filter(
        (item) => item !== "all"
      );
    }
    if (this.state.selectedProvince) {
      filters.where["subOrg"] = this.state.selectedProvince;
    } else {
      delete filters.where["subOrg"];
    }
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleView = (item) => {
    this.state.item = item;
    this.setState({ modalView: !this.state.modalView });
  };

  handleCloseModel = () => {
    this.setState({ modalView: false });
  };

  handleDateChangeStart = (gte) => {
    const { filters } = this.state;
    filters.where.gte = datetimeHelper.toFormat(gte, "YYYY-MM-DD HH:mm");
    this.setState({ gte });
  };

  handleDateChangeEnd = (lte) => {
    const { filters } = this.state;
    filters.where.lte = datetimeHelper.toFormat(lte, "YYYY-MM-DD HH:mm");
    this.setState({ lte });
  };

  callNumber = (item) => {
    const { agentStatus } = this.props;
    this.props.handleClickToCall({
      to: item.toNumber,
      extensionId: agentStatus ? agentStatus.extensionId : null,
    });
  };

  export = () => {
    const { filters } = this.state;
    const where = {};
    const and = [];
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "answeredDuration":
              let _and = [];
              switch (element) {
                case "1":
                  _and = [
                    {
                      answeredDuration: {
                        gte: 0,
                      },
                    },
                    {
                      answeredDuration: {
                        lt: 60,
                      },
                    },
                  ];
                  break;
                case "2":
                  _and = [
                    {
                      answeredDuration: {
                        gte: 60,
                      },
                    },
                    {
                      answeredDuration: {
                        lt: 180,
                      },
                    },
                  ];
                  break;
                case "3":
                  _and = [
                    {
                      answeredDuration: {
                        gte: 180,
                      },
                    },
                    {
                      answeredDuration: {
                        lt: 300,
                      },
                    },
                  ];
                  break;
                case "4":
                  _and = [
                    {
                      answeredDuration: {
                        gte: 300,
                      },
                    },
                    {
                      answeredDuration: {
                        lt: 600,
                      },
                    },
                  ];
                  break;
                case "5":
                  _and = [
                    {
                      answeredDuration: {
                        gte: 600,
                      },
                    },
                  ];
                  break;
                default:
                  break;
              }
              where.and = and.concat(_and);
              break;
            case "status":
              if (element.startsWith("missed")) {
                if (element === "missedNoExtension") {
                  where["extensionId"] = { eq: "" };
                } else if (element === "missed") {
                  where["extensionId"] = { neq: "" };
                }
                where[key] = "missed";
              } else {
                where[key] = element;
              }
              break;
            case "extensionId":
              if (
                JSON.stringify(where["extensionId"]) === '{"neq":""}' ||
                !where["extensionId"]
              ) {
                where[key] = element;
              } else {
                where[key] = { eq: "" };
              }
              break;
            case "fromNumber":
            case "toNumber":
            default: {
              if (key.startsWith("gte") || key.startsWith("lte")) {
                if (key == "gte") {
                  and.push({
                    startedAt: { gte: this.state.filters.where.gte },
                  });
                  where.and = and;
                } else {
                  and.push({
                    startedAt: { lte: this.state.filters.where.lte },
                  });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }

    this.setState(
      {
        loadingExcel: true,
      },
      () => {
        exportInbound({ where: where })
          .then((res) => {
            this.setState(
              {
                loadingExcel: false,
              },
              () => {
                if (res.data.fileUrl) {
                  if (res.data.fileUrl) {
                    const fileName = res.data.fileUrl.split("/").pop();
                    saveAs(res.data.fileUrl, fileName);
                  }
                }
              }
            );
          })
          .catch((error) => {
            this.setState({
              loadingExcel: false,
            });
          });
      }
    );
  };

  handleSearchUser = (text) => {
    const { listUser } = this.props;
    this.setState({
      listUser: filterCustomers(_.values(listUser), text),
    });
  };

  onHandleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      this.handleSubmit();
    }
  };

  handleSearchProvince = (text) => {
    const { findProvince } = this.props;
    findProvince(text, 10);
  };

  filterCustomers = (array, search) => {
    if (search) {
      return search
        ? array.filter(
            (item) =>
              item &&
              item.name &&
              item.name.toLowerCase().includes(search.toLowerCase())
            // (item && item.username && item.username.toLowerCase().includes(search.toLowerCase()))
          )
        : array;
    }
    return array;
  };

  render() {
    const {
      classes,
      listInbound,
      count,
      listPhoneNumber,
      listAgentGroups,
      listExtension,
      foundProvinces,
      findLoading,
    } = this.props;
    const { filters } = this.state;
    const listInboundResult =
      typeof listInbound === "object"
        ? Object.keys(listInbound).map((key) => listInbound[key])
        : listInbound;
    const listPhoneNumberResult =
      typeof listPhoneNumber === "object"
        ? Object.keys(listPhoneNumber).map((key) => listPhoneNumber[key])
        : listPhoneNumber;
    const listAgentGroupsResult =
      typeof listAgentGroups === "object"
        ? Object.keys(listAgentGroups).map((key) => listAgentGroups[key])
        : listAgentGroups;
    const listExtensionResult =
      typeof listExtension === "object"
        ? Object.keys(listExtension).map((key) => listExtension[key])
        : listExtension;
    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid
                      container
                      spacing={24}
                      style={{ justifyContent: "flex-end" }}>
                      <Grid item md={3}>
                        <SelectAutoComplete
                          label={"Bưu cục"}
                          data={
                            foundProvinces && foundProvinces.length > 0
                              ? foundProvinces.map((val) => {
                                  return {
                                    code: val.code,
                                    label: `${val.name}`,
                                  };
                                })
                              : []
                          }
                          onSearch={debounce(
                            (text) => this.handleSearchProvince(text),
                            300
                          )}
                          onChange={(item) => {
                            this.setState({
                              selectedProvince: item ? item.code : "",
                            });
                          }}
                          className={classes.input}
                          onClear={true}
                          name="subOrg"
                          loading={findLoading}
                        />
                      </Grid>
                      <Grid item md={3}>
                        <TextValidator
                          id="outlined-full-width"
                          margin="normal"
                          label="SĐT bưu tá"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={filters.where.fromNumber}
                          name="fromNumber"
                          onKeyPress={(e) => this.onHandleKeyPress(e)}
                        />
                      </Grid>

                      <Grid item md={3}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian gọi từ"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.gte}
                          maxDate={new Date()}
                          format="yyyy/MM/dd HH:mm"
                          onChange={this.handleDateChangeStart}
                          name="gte"
                          keyboard
                          ampm={false}
                          mask={[
                            /\d/,
                            /\d/,
                            /\d/,
                            /\d/,
                            "/",
                            /\d/,
                            /\d/,
                            "/",
                            /\d/,
                            /\d/,
                            " ",
                            /\d/,
                            /\d/,
                            ":",
                            /\d/,
                            /\d/,
                          ]}
                        />
                      </Grid>

                      <Grid item md={3}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian gọi đến"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.lte}
                          maxDate={new Date()}
                          minDate={filters.where.gte}
                          format="yyyy/MM/dd HH:mm"
                          onChange={this.handleDateChangeEnd}
                          name="lte"
                          keyboard
                          ampm={false}
                          mask={[
                            /\d/,
                            /\d/,
                            /\d/,
                            /\d/,
                            "/",
                            /\d/,
                            /\d/,
                            "/",
                            /\d/,
                            /\d/,
                            " ",
                            /\d/,
                            /\d/,
                            ":",
                            /\d/,
                            /\d/,
                          ]}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      spacing={24}
                      style={{ justifyContent: "flex-end" }}>
                      <Grid item md={3}>
                        <SelectValidator
                          id="outlined-full-width"
                          margin="normal"
                          select
                          SelectProps={{
                            MenuProps: {
                              className: classes.menu,
                              shrink: true,
                            },
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Trạng thái"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={filters.where.status}
                          name="status">
                          <MenuItem>Tất cả</MenuItem>
                          <MenuItem key="answered" value="answered">
                            Answered
                          </MenuItem>
                          <MenuItem key="busy" value="busy">
                            Busy
                          </MenuItem>
                          <MenuItem key="no-answered" value="no-answered">
                            No-Answered
                          </MenuItem>
                          <MenuItem key="failed" value="failed">
                            Failed
                          </MenuItem>
                        </SelectValidator>
                      </Grid>

                      <Grid item md={3}>
                        <TextValidator
                          id="outlined-full-width"
                          margin="normal"
                          label="Mã vận đơn"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={filters.where["attributes.ladingCode"]}
                          name="attributes.ladingCode"
                          onKeyPress={(e) => this.onHandleKeyPress(e)}
                        />
                      </Grid>

                      <Grid item md={3}>
                        <SelectValidator
                          id="outlined-full-width"
                          margin="normal"
                          select
                          SelectProps={{
                            MenuProps: {
                              className: classes.menu,
                              shrink: true,
                            },
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Thời lượng trả lời"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={filters.where.answeredDuration}
                          name="answeredDuration">
                          <MenuItem>Tất cả</MenuItem>
                          <MenuItem key="1" value="1">
                            Cuộc gọi nhỏ hơn 1 phút
                          </MenuItem>
                          <MenuItem key="2" value="2">
                            Cuộc gọi từ 1 phút đến 3 phút
                          </MenuItem>
                          <MenuItem key="3" value="3">
                            Cuộc gọi từ 3 phút đến 5 phút
                          </MenuItem>
                          <MenuItem key="4" value="4">
                            Cuộc gọi từ 5 phút đến 10 phút
                          </MenuItem>
                          <MenuItem key="5" value="5">
                            Cuộc gọi lớn hơn 10 phút
                          </MenuItem>
                        </SelectValidator>
                      </Grid>

                      <Grid item md={3}>
                        <TextValidator
                          id="outlined-full-width"
                          margin="normal"
                          label="Số điện thoại KH"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={filters.where.referTo}
                          name="referTo"
                          onKeyPress={(e) => this.onHandleKeyPress(e)}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      spacing={24}
                      style={{ justifyContent: "flex-end" }}>
                      <Grid
                        item
                        md={3}
                        style={{ justifyContent: "flex-end", display: "flex" }}>
                        <Tooltip title="Tìm kiếm" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            className={classes.fab}
                            onClick={this.handleSubmit}>
                            <Search />
                          </Fab>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <TableData
          {...this.props}
          nameTable="Danh sách cuộc gọi"
          items={listInboundResult}
          rowsPerPage={filters.pageSize}
          count={count ? count.count : 0}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listColumns}
          handleView={this.handleView}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          callNumber={this.callNumber}
          createAction={
            <React.Fragment>
              <Tooltip title="Tải báo cáo" disableFocusListener>
                <Fab
                  color="primary"
                  size="small"
                  aria-label="export"
                  className={classes.fab}
                  onClick={this.export}>
                  <Icon className={classes.add}>save_alt</Icon>
                </Fab>
              </Tooltip>
            </React.Fragment>
          }
        />
        <Dialog
          open={this.state.modalView}
          onClose={this.handleCloseModel}
          title="Chi tiết cuộc gọi"
          buttonExit={true}
          fullwidth={true}
          input={
            <Grid container spacing={24}>
              <audio
                ref="audio"
                src={this.state.item ? getRecordFileUrl(this.state.item) : ""}
                controls
                autoPlay={false}
                style={{ width: "100%", marginTop: 20 }}
              />
              <Grid item md={6}>
                <TextField
                  multiline
                  maxRow={2}
                  id="standard-name"
                  label="Bưu cục"
                  className={classes.input}
                  value={
                    this.state.item
                      ? this.state.item?.attributes?.province?.name
                      : ""
                  }
                  margin="normal"
                />
                <TextField
                  label="SĐT Đón"
                  className={classes.input}
                  value={this.state.item ? this.state.item.toNumber : ""}
                  margin="normal"
                />
                <TextField
                  id="standard-name"
                  label="Họ tên Bưu tá"
                  className={classes.input}
                  value={
                    this.state.item
                      ? this.state.item?.attributes?.postMan?.fullname
                      : ""
                  }
                  margin="normal"
                />
                <TextField
                  id="standard-name"
                  label="Thời gian gọi"
                  className={classes.input}
                  value={
                    this.state.item
                      ? datetimeHelper.toFormat(
                          this.state.item.startedAt,
                          "YYYY-MM-DD HH:mm:ss"
                        )
                      : ""
                  }
                  margin="normal"
                />
                <TextField
                  id="standard-name"
                  label="Thời gian kết nối"
                  className={classes.input}
                  value={
                    this.state.item
                      ? datetimeHelper.secondToHHMMSS(this.state.item.duration)
                      : ""
                  }
                  margin="normal"
                />
              </Grid>
              <Grid item md={6}>
                <TextField
                  id="standard-name"
                  label="SĐT Bưu tá"
                  className={classes.input}
                  value={this.state.item ? this.state.item.fromNumber : ""}
                  margin="normal"
                />
                <TextField
                  label="SĐT Gọi"
                  className={classes.input}
                  value={this.state.item ? this.state.item.referVia : ""}
                  margin="normal"
                />
                <TextField
                  id="standard-name"
                  label="Số điện thoại KH"
                  className={classes.input}
                  value={this.state.item ? this.state.item.referTo : ""}
                  margin="normal"
                />
                <TextField
                  id="standard-name"
                  label="Trạng thái"
                  className={classes.input}
                  value={this.state.item ? this.state.item.status : ""}
                  margin="normal"
                />
                <TextField
                  id="standard-name"
                  label="Thời gian trả lời"
                  className={classes.input}
                  value={
                    this.state.item
                      ? datetimeHelper.secondToHHMMSS(
                          this.state.item.answeredDuration
                        )
                      : ""
                  }
                  margin="normal"
                />
              </Grid>
              <Grid item md={12}>
                <TextField
                  id="standard-name"
                  label="Mã vận đơn"
                  className={classes.input}
                  value={
                    this.state.item
                      ? this.state.item?.attributes?.ladingCode
                      : ""
                  }
                  margin="normal"
                />
              </Grid>
            </Grid>
          }
        />
        <Dialog open={this.props.loading} title={<CircularProgress />} />
        <Dialog open={this.state.loadingExcel} title={<CircularProgress />} />
      </React.Fragment>
    );
  }
}

PostmanCalls.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  listInbound: state.inboundCall.inbound,
  count: state.inboundCall.count,
  agentStatus: state.agent.status,
  loading: state.inboundCall.loading,
  listPhoneNumber: state.phoneNumber.phoneNumbers,
  listAgentGroups: state.agent.groupAgent,
  listExtension: state.user.subOrgs,
  listUser: state.agent.agents,
  foundProvinces: state.user.foundProvinces,
  findLoading: state.user.findLoading,
});

PostmanCalls = connect(mapStateToProps, mapActionsToProps)(PostmanCalls);
const ClickToCall = connect(null, clickToCallAction)(PostmanCalls);
const Agent = connect(null, agent)(ClickToCall);
const Province = connect(null, provinceAction)(Agent);
const PhoneNumber = connect(null, phoneNumberAction)(Province);

export default withStyles(styles)(PhoneNumber);
